<div class="row">
    <div class="col-xl-6">
        <div class="card card-box bg-neutral-first border-2 card-border-top border-first text-center mb-5">
            <div class="py-5 px-5">
                <h4 class="font-size-xl font-weight-bold mb-2">Technical Support</h4>
                <p class="opacity-6 font-size-md mb-3">
                    He lay on his armour-like back, and if he lifted his head.
                </p>
                <button class="btn btn-first text-nowrap px-4 text-uppercase font-size-sm">
                    <small class="font-weight-bold">Send Email</small>
                </button>
            </div>
        </div>
        <div class="card card-box bg-composed-wrapper bg-plum-plate border-0 text-center mb-5">
            <div class="bg-composed-img-4 bg-composed-wrapper--image rounded"></div>
            <div class="bg-composed-wrapper--content text-light p-5">
                <h4 class="font-size-xl font-weight-bold mb-2">Technical Support</h4>
                <p class="opacity-6 font-size-md mb-3">
                    He lay on his armour-like back, and if he lifted his head.
                </p>
                <button class="btn btn-warning text-nowrap px-4 text-uppercase font-size-sm">
                    <small class="font-weight-bold">Send Email</small>
                </button>
            </div>
        </div>
    </div>
    <div class="col-xl-6">
        <div class="card card-box bg-neutral-danger border-2 card-border-top border-danger text-center mb-5">
            <div class="py-5 px-5">
                <h4 class="font-size-xl font-weight-bold mb-2">Knowledge Base Software</h4>
                <p class="opacity-6 font-size-md mb-3">
                    Sed ut perspiciatis unde omnis iste natus error sit voluptatem.
                </p>
                <button class="btn btn-danger text-nowrap px-4 text-uppercase font-size-sm">
                    <small class="font-weight-bold">Contact us</small>
                </button>
            </div>
        </div>
        <div class="card card-box bg-composed-wrapper bg-midnight-bloom border-0 text-center mb-5">
            <div class="bg-composed-img-2 bg-composed-wrapper--image rounded"></div>
            <div class="bg-composed-wrapper--content text-light p-5">
                <h4 class="font-size-xl font-weight-bold mb-2">Knowledge Base Software</h4>
                <p class="opacity-6 font-size-md mb-3">
                    Sed ut perspiciatis unde omnis iste natus error sit voluptatem.
                </p>
                <button class="btn btn-danger text-nowrap px-4 text-uppercase font-size-sm">
                    <small class="font-weight-bold">Contact us</small>
                </button>
            </div>
        </div>
    </div>
</div>
